<template>
    <div class="card">
        <div class="row" v-if="!isLoaded">
            <div class="col-12" style="text-align: center; margin-top: 20px;">
                <span>Загружаем данные...</span>
            </div>
        </div>
        <div class="row">
            <div class="col-12" style="padding: 20px;">
                <table class="table table-bordered table-hover datatable">
                    <thead>
                        <tr style="text-align: center;">
                            <th style="text-align: left;">
                                <autocomplete
                                    :search="searchPairs"
                                    @submit="onSubmitPair"
                                ></autocomplete>
                            </th>
                            <th colspan="3">1 сек</th>
                            <th colspan="2">3 мин</th>
                            <th colspan="2">4 ч</th>
                            <th colspan="2">8 ч</th>
                            <th colspan="2">24 ч</th>
                        </tr>
                        <tr>
                            <th>Пара <i :class="{
                                'fas': true, 'fa-sort': sortColumn !== 'symbol',
                                'fa-sort-up': sortColumn === 'symbol' && sortDirection === 'asc',
                                'fa-sort-down': sortColumn === 'symbol' && sortDirection === 'desc'}"
                                        @click="changeSort('symbol')"
                                        style="cursor: pointer;"></i>
                            </th>
                            <th>Цена <i :class="{
                                'fas': true, 'fa-sort': sortColumn !== 'price',
                                'fa-sort-up': sortColumn === 'price' && sortDirection === 'asc',
                                'fa-sort-down': sortColumn === 'price' && sortDirection === 'desc'}"
                                        @click="changeSort('price')"
                                        style="cursor: pointer;"></i>
                            </th>
                            <th>Изменение цены, % <i :class="{
                                'fas': true, 'fa-sort': sortColumn !== 'diffPercent1Sec',
                                'fa-sort-up': sortColumn === 'diffPercent1Sec' && sortDirection === 'asc',
                                'fa-sort-down': sortColumn === 'diffPercent1Sec' && sortDirection === 'desc'}"
                                                    @click="changeSort('diffPercent1Sec')"
                                                    style="cursor: pointer;"></i>
                            </th>
                            <th>Изменение цены, к BTC %, +/- <i :class="{
                                'fas': true, 'fa-sort': sortColumn !== 'diffPercent1SecBtc',
                                'fa-sort-up': sortColumn === 'diffPercent1SecBtc' && sortDirection === 'asc',
                                'fa-sort-down': sortColumn === 'diffPercent1SecBtc' && sortDirection === 'desc'}"
                                                                @click="changeSort('diffPercent1SecBtc')"
                                                                style="cursor: pointer;"></i>
                            </th>
                            <th>Изменение цены, % <i :class="{
                                'fas': true, 'fa-sort': sortColumn !== 'diffPercent3Min',
                                'fa-sort-up': sortColumn === 'diffPercent3Min' && sortDirection === 'asc',
                                'fa-sort-down': sortColumn === 'diffPercent3Min' && sortDirection === 'desc'}"
                                                     @click="changeSort('diffPercent3Min')"
                                                     style="cursor: pointer;"></i>
                            </th>
                            <th>Изменение цены, к BTC %, +/- <i :class="{
                                'fas': true, 'fa-sort': sortColumn !== 'diffPercent3MinBtc',
                                'fa-sort-up': sortColumn === 'diffPercent3MinBtc' && sortDirection === 'asc',
                                'fa-sort-down': sortColumn === 'diffPercent3MinBtc' && sortDirection === 'desc'}"
                                                                @click="changeSort('diffPercent3MinBtc')"
                                                                style="cursor: pointer;"></i>
                            </th>
                            <th>Изменение цены, % <i :class="{
                                'fas': true, 'fa-sort': sortColumn !== 'diffPercent4Hour',
                                'fa-sort-up': sortColumn === 'diffPercent4Hour' && sortDirection === 'asc',
                                'fa-sort-down': sortColumn === 'diffPercent4Hour' && sortDirection === 'desc'}"
                                                     @click="changeSort('diffPercent4Hour')"
                                                     style="cursor: pointer;"></i>
                            </th>
                            <th>Изменение цены, к BTC %, +/- <i :class="{
                                'fas': true, 'fa-sort': sortColumn !== 'diffPercent4HourBtc',
                                'fa-sort-up': sortColumn === 'diffPercent4HourBtc' && sortDirection === 'asc',
                                'fa-sort-down': sortColumn === 'diffPercent4HourBtc' && sortDirection === 'desc'}"
                                                                @click="changeSort('diffPercent4HourBtc')"
                                                                style="cursor: pointer;"></i>
                            </th>
                            <th>Изменение цены, % <i :class="{
                                'fas': true, 'fa-sort': sortColumn !== 'diffPercent8Hour',
                                'fa-sort-up': sortColumn === 'diffPercent8Hour' && sortDirection === 'asc',
                                'fa-sort-down': sortColumn === 'diffPercent8Hour' && sortDirection === 'desc'}"
                                                     @click="changeSort('diffPercent8Hour')"
                                                     style="cursor: pointer;"></i>
                            </th>
                            <th>Изменение цены, к BTC %, +/- <i :class="{
                                'fas': true, 'fa-sort': sortColumn !== 'diffPercent8HourBtc',
                                'fa-sort-up': sortColumn === 'diffPercent8HourBtc' && sortDirection === 'asc',
                                'fa-sort-down': sortColumn === 'diffPercent8HourBtc' && sortDirection === 'desc'}"
                                                                @click="changeSort('diffPercent8HourBtc')"
                                                                style="cursor: pointer;"></i>
                            </th>
                            <th>Изменение цены, % <i :class="{
                                'fas': true, 'fa-sort': sortColumn !== 'diffPercent24Hour',
                                'fa-sort-up': sortColumn === 'diffPercent24Hour' && sortDirection === 'asc',
                                'fa-sort-down': sortColumn === 'diffPercent24Hour' && sortDirection === 'desc'}"
                                                     @click="changeSort('diffPercent24Hour')"
                                                     style="cursor: pointer;"></i>
                            </th>
                            <th>Изменение цены, к BTC %, +/- <i :class="{
                                'fas': true, 'fa-sort': sortColumn !== 'diffPercent24HourBtc',
                                'fa-sort-up': sortColumn === 'diffPercent24HourBtc' && sortDirection === 'asc',
                                'fa-sort-down': sortColumn === 'diffPercent24HourBtc' && sortDirection === 'desc'}"
                                                                @click="changeSort('diffPercent24HourBtc')"
                                                                style="cursor: pointer;"></i>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in rows">
                            <td style="white-space: nowrap;">{{ connectedSymbols.includes(row.symbol) ? '🟢' : '🔴' }} <b><a :href="'https://www.binance.com/ru-UA/trade/' + row.symbol" target="_blank">{{ row.symbol }}</a></b></td>
                            <td>{{ parseFloat(row.price).toFixed(5) }}</td>
                            <td :style="{color: row.diffPercent1Sec >= 0 ? 'green' : 'red'}">{{ row.diffPercent1Sec.toFixed(5) }}</td>
                            <td :style="{color: row.diffPercent1SecBtc >= 0 ? 'green' : 'red'}">{{ row.diffPercent1SecBtc.toFixed(5) }}</td>
                            <td :style="{color: row.diffPercent3Min >= 0 ? 'green' : 'red'}">{{ row.diffPercent3Min.toFixed(3) }}</td>
                            <td :style="{color: row.diffPercent3MinBtc >= 0 ? 'green' : 'red'}">{{ row.diffPercent3MinBtc.toFixed(3) }}</td>
                            <td :style="{color: row.diffPercent4Hour >= 0 ? 'green' : 'red'}">{{ row.diffPercent4Hour.toFixed(3) }}</td>
                            <td :style="{color: row.diffPercent4HourBtc >= 0 ? 'green' : 'red'}">{{ row.diffPercent4HourBtc.toFixed(3) }}</td>
                            <td :style="{color: row.diffPercent8Hour >= 0 ? 'green' : 'red'}">{{ row.diffPercent8Hour.toFixed(3) }}</td>
                            <td :style="{color: row.diffPercent8HourBtc >= 0 ? 'green' : 'red'}">{{ row.diffPercent8HourBtc.toFixed(3) }}</td>
                            <td :style="{color: row.diffPercent24Hour >= 0 ? 'green' : 'red'}">{{ row.diffPercent24Hour.toFixed(3) }}</td>
                            <td :style="{color: row.diffPercent24HourBtc >= 0 ? 'green' : 'red'}">{{ row.diffPercent24HourBtc.toFixed(3) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import Binance from 'binance-api-node';
    // import { WebsocketClient } from 'binance';
    import SocketIO from 'socket.io-client'
    import Autocomplete from '@trevoreyre/autocomplete-vue'
    import '@trevoreyre/autocomplete-vue/dist/style.css'

    export default {
        components: { Autocomplete },
        data() {
            return {
                binanceClient: null,
                wsClient: null,
                symbols: [],
                connectedSymbols: [],
                candles: {},
                btcCandles: [],
                rows: [],
                isLoaded: false,
                isUpdating: false,
                socket: null,
                isConnected: false,
                filterPair: '',
                sortColumn: '',
                sortDirection: 'desc',
            }
        },
        computed: {
        },
        beforeDestroy() {
            console.log('DISCONNECT');
            this.socket.disconnect();
        },
        async mounted() {
            console.log('Component mounted.')

            this.binanceClient = new Binance();

            const spotExchangeInfo = await this.binanceClient.exchangeInfo();
            const spotSymbols = spotExchangeInfo.symbols.map((symbolItem) => { return symbolItem.symbol; });

            const futuresExchangeInfo = await this.binanceClient.futuresExchangeInfo();
            const futuresSymbols = futuresExchangeInfo.symbols.map((symbolItem) => { return symbolItem.symbol; });

            this.symbols = spotSymbols.filter((symbol) => {
                return symbol.includes('USDT') && futuresSymbols.includes(symbol);
            })/*.slice(0, 50)*/.sort();
            // this.symbols = ['EGLDUSDT', 'BTCUSDT'];

            const candlesLast = await this.binanceClient.candles({ symbol: 'BTCUSDT', interval: '1m', limit: 1000 });
            const candlesFirst = await this.binanceClient.candles({ symbol: 'BTCUSDT', interval: '1m', limit: 500, endTime: candlesLast[0].openTime - 1 });
            this.btcCandles = candlesFirst.concat(candlesLast);

            this.symbols.forEach((symbol) => {
                this.initPair(symbol);
            });

            /*this.binanceClient.ws.candles(this.symbols, '1s', candle => {
                candle.openTime = candle.startTime;

                if (this.candles[candle.symbol] && this.candles[candle.symbol][this.candles[candle.symbol].length - 1].closeTime < candle.openTime) {
                    this.candles[candle.symbol].push(candle);
                }
                console.log(candle)

                if (!this.connectedSymbols.includes(candle.symbol)) {
                    this.connectedSymbols.push(candle.symbol);
                }
            });*/

            /*this.wsClient = new WebsocketClient({});
            this.symbols.forEach((symbol) => {
                this.wsClient.on('formattedMessage', (candle) => {
                    candle.openTime = candle.startTime;

                    if (this.candles[candle.symbol] && this.candles[candle.symbol][this.candles[candle.symbol].length - 1].closeTime < candle.openTime) {
                        this.candles[candle.symbol].push(candle);
                    }
                    console.log(candle.symbol)
                });
                this.wsClient.subscribeKlines(symbol, '1s', 'spot');
            });*/

            this.connect();

            setInterval(this.updateRows, 1000);
        },
        methods: {
            /*subscribeSymbol(symbol) {
                this.binanceClient.ws.candles(symbol, '1s', candle => {
                    candle.openTime = candle.startTime;

                    if (this.candles[candle.symbol] && this.candles[candle.symbol][this.candles[candle.symbol].length - 1].closeTime < candle.openTime) {
                        this.candles[candle.symbol].push(candle);
                    }
                    console.log(candle.symbol)
                });
            },*/
            async initPair(symbol) {
                const candlesLast = await this.binanceClient.candles({ symbol: symbol, interval: '1m', limit: 1000 });
                const candlesFirst = await this.binanceClient.candles({ symbol: symbol, interval: '1m', limit: 500, endTime: candlesLast[0].openTime - 1 });
                this.candles[symbol] = candlesFirst.concat(candlesLast);
            },
            updateRows() {
                if (this.isUpdating) {
                    return;
                }

                this.isUpdating = true;

                let rows = [];
                let btcRow = null;
                this.symbols.forEach((symbol) => {
                    if (!this.candles[symbol]) {
                        return;
                    }

                    if (this.filterPair !== '' && !['BTCUSDT', this.filterPair].includes(symbol)) {
                        return;
                    }

                    const lastCandle = this.candles[symbol][this.candles[symbol].length - 1];

                    let row = {
                        symbol: symbol,
                        price: lastCandle.close ?? 0,
                        diff1Sec: 0,
                        diffPercent1Sec: 0,
                        diff3Min: 0,
                        diffPercent3Min: 0,
                        diff4Hour: 0,
                        diffPercent4Hour: 0,
                        diff8Hour: 0,
                        diffPercent8Hour: 0,
                        diff24Hour: 0,
                        diffPercent24Hour: 0,
                    };

                    [].concat(this.candles[symbol]).reverse().forEach((candle) => {
                        if (candle.closeTime === lastCandle.closeTime - 1000) {
                            row.diff1Sec = lastCandle.close - candle.close;
                            row.diffPercent1Sec = row.diff1Sec / candle.close * 100;
                        } else if (candle.openTime <= lastCandle.closeTime - 3 * 60000 && candle.closeTime >= lastCandle.closeTime - 3 * 60000) {
                            row.diff3Min = lastCandle.close - candle.close;
                            row.diffPercent3Min = row.diff3Min / candle.close * 100;
                        } else if (candle.openTime <= lastCandle.closeTime - 4 * 60 * 60000 && candle.closeTime >= lastCandle.closeTime - 4 * 60 * 60000) {
                            row.diff4Hour = lastCandle.close - candle.close;
                            row.diffPercent4Hour = row.diff4Hour / candle.close * 100;
                        } else if (candle.openTime <= lastCandle.closeTime - 8 * 60 * 60000 && candle.closeTime >= lastCandle.closeTime - 8 * 60 * 60000) {
                            row.diff8Hour = lastCandle.close - candle.close;
                            row.diffPercent8Hour = row.diff8Hour / candle.close * 100;
                        } else if (candle.openTime <= lastCandle.closeTime - 24 * 60 * 60000 && candle.closeTime >= lastCandle.closeTime - 24 * 60 * 60000) {
                            row.diff24Hour = lastCandle.close - candle.close;
                            row.diffPercent24Hour = row.diff24Hour / candle.close * 100;
                        }
                    });

                    /*const kline1Sec = this.candles[symbol].find((candle) => {
                        return candle.closeTime === lastCandle.closeTime - 1000;
                    });
                    row.diff1Sec = kline1Sec ? lastCandle.close - kline1Sec.close : 0;
                    row.diffPercent1Sec = row.diff1Sec ? row.diff1Sec / kline1Sec.close * 100 : 0;

                    const kline3Min = this.candles[symbol].find((candle) => {
                        return candle.openTime <= lastCandle.closeTime - 3 * 60000 && candle.closeTime >= lastCandle.closeTime - 3 * 60000;
                    });
                    row.diff3Min = kline3Min ? lastCandle.close - kline3Min.close : 0;
                    row.diffPercent3Min = row.diff3Min ? row.diff3Min / kline3Min.close * 100 : 0;

                    const kline4Hour = this.candles[symbol].find((candle) => {
                        return candle.openTime <= lastCandle.closeTime - 4 * 60 * 60000 && candle.closeTime >= lastCandle.closeTime - 4 * 60 * 60000;
                    });
                    row.diff4Hour = kline4Hour ? lastCandle.close - kline4Hour.close : 0;
                    row.diffPercent4Hour = row.diff4Hour ? row.diff4Hour / kline4Hour.close * 100 : 0;

                    const kline8Hour = this.candles[symbol].find((candle) => {
                        return candle.openTime <= lastCandle.closeTime - 8 * 60 * 60000 && candle.closeTime >= lastCandle.closeTime - 8 * 60 * 60000;
                    });
                    row.diff8Hour = kline8Hour ? lastCandle.close - kline8Hour.close : 0;
                    row.diffPercent8Hour = row.diff8Hour ? row.diff8Hour / kline8Hour.close * 100 : 0;

                    const kline24Hour = this.candles[symbol].find((candle) => {
                        return candle.openTime <= lastCandle.closeTime - 24 * 60 * 60000 && candle.closeTime >= lastCandle.closeTime - 24 * 60 * 60000;
                    });
                    row.diff24Hour = kline24Hour ? lastCandle.close - kline24Hour.close : 0;
                    row.diffPercent24Hour = row.diff24Hour ? row.diff24Hour / kline24Hour.close * 100 : 0;*/


                    if (symbol === 'BTCUSDT') {
                        btcRow = row;
                        btcRow.diffPercent1SecBtc = 0;
                        btcRow.diffPercent3MinBtc = 0;
                        btcRow.diffPercent4HourBtc = 0;
                        btcRow.diffPercent8HourBtc = 0;
                        btcRow.diffPercent24HourBtc = 0;
                    } else {
                        rows.push(row);
                    }
                });

                if (btcRow) {
                    rows.forEach((row) => {
                        row.diffPercent1SecBtc = row.diffPercent1Sec - btcRow.diffPercent1Sec;
                        row.diffPercent3MinBtc = row.diffPercent3Min - btcRow.diffPercent3Min;
                        row.diffPercent4HourBtc = row.diffPercent4Hour - btcRow.diffPercent4Hour;
                        row.diffPercent8HourBtc = row.diffPercent8Hour - btcRow.diffPercent8Hour;
                        row.diffPercent24HourBtc = row.diffPercent24Hour - btcRow.diffPercent24Hour;
                    });
                }

                rows = rows.sort((a, b) => {
                    if (isNaN(parseFloat(a[this.sortColumn]))) {
                        if (this.sortDirection === 'asc' ? a[this.sortColumn] < b[this.sortColumn] : b[this.sortColumn] < a[this.sortColumn]) return -1;
                        else return 1;
                    }
                    return this.sortDirection === 'asc' ? a[this.sortColumn] - b[this.sortColumn] : b[this.sortColumn] - a[this.sortColumn];
                })

                if (btcRow) {
                    rows.unshift(btcRow);
                }

                this.rows = rows;

                if (!this.isLoaded) {
                    let isLoaded = true;
                    for (let i = 0; i < this.symbols.length; i++) {
                        // console.log(this.symbols[i] + ' - ' + this.candles[this.symbols[i]].length)
                        if (!this.candles[this.symbols[i]] || this.candles[this.symbols[i]].length < 1500) {
                            isLoaded = false;
                            break;
                        }
                    }
                    this.isLoaded = isLoaded;
                }

                this.isUpdating = false;
                // console.log('updated');
                // console.log(this.candles)
            },
            connect: function (){
                if(!this.isConnected){
                    this.socket = SocketIO.connect('https://ts-spot-socket.atla.com.ua', {
                        transportOptions: {
                            polling: {
                                extraHeaders: {}
                            }
                        }
                    });

                    this.socket.on('connect',function(socket) {
                        console.log('connect');
                    });

                    this.isConnected = true;

                    this.socket.on('kline', (candle) => {
                        candle.openTime = candle.startTime;
                        candle.closeTime = candle.endTime;

                        if (this.candles[candle.symbol] && this.candles[candle.symbol][this.candles[candle.symbol].length - 1].closeTime < candle.openTime) {
                            this.candles[candle.symbol].push(candle);
                        }
                        // console.log(candle)

                        if (!this.connectedSymbols.includes(candle.symbol)) {
                            this.connectedSymbols.push(candle.symbol);
                        }
                    });
                }
            },
            searchPairs(input) {
                if (input.length < 1) {
                    this.filterPair = '';
                    return this.symbols;
                }
                return this.symbols.filter(pair => {
                    return pair.toLowerCase()
                        .startsWith(input.toLowerCase())
                })
            },
            onSubmitPair(input) {
                this.filterPair = input;
            },
            changeSort(col) {
                if (this.sortColumn !== col) {
                    this.sortDirection = 'desc';
                } else {
                    this.sortDirection = this.sortDirection === 'desc' ? 'asc' : 'desc';
                }
                this.sortColumn = col;
            },
        },
    }
</script>
